import {CreateInstance} from './config'
import {i18n} from '@/i18n'

const deviceGroupAPI = CreateInstance('device-groups')

// 기본그룹(flag_df_group) name을 현재 언어에 맞게 치환
deviceGroupAPI.interceptors.response.use(resp => {
  if (resp.data && resp.data.objects) {
    const objects = Array.isArray(resp.data.objects) ? resp.data.objects : [resp.data.objects]
    objects.forEach(group => {
      if (group.flag_df_group) {
        group.name = i18n.t('default_group')
      }
    })
  }
  return resp
})

export default deviceGroupAPI
